import './time.css'
import React from 'react'
import { useState } from 'react'

import Header from '../components/shared/header'
import PageTitle from '../components/basic/page-title'
import Steps from '../components/pages/services/steps'
import ProfessionalCard from '../components/pages/professionals/professional-card'
import AnyProfessionalCard from '../components/pages/professionals/any-professional-card'
import ChangeProfessionalCard from '../components/pages/time/change-professional-card'
import Button from '../components/basic/button'
import SelectDay from '../components/pages/time/select-day'
import SelectHour from '../components/pages/time/select-hour'



const Time = () => {

    const [active, setActive] = useState('false');

    const handleSelectHour = (event) => {
        document
            .querySelectorAll('.container-hour')
            .forEach(card => card.classList.remove('selected'));

        event.currentTarget.classList.add('selected');

        setActive('true');
    };

    return (

        <div className="screen-main">

            <Header leftIcon="arrowLeft" label="Agenda" rightIcon="bell" action="/professionals" />

            <Steps Step="3" />

            <ChangeProfessionalCard Action='/professionals' Description='Corte Feminino' Duration='45 min' Price='R$ 40,00' URLPicture='/assets/img019.png' />

            <PageTitle Title='Escolha o dia e horário' Description='Veja os dias disponíveis e selecione o melhor horário para você.' />

            <div className="professionals-content">
                <p className='app-sub-title day-avalaible'>Selecione o dia</p>
                <SelectDay />

                <p className='app-sub-title hour-avalaible'>Horários disponíveis</p>
                <div className='container-hours'>
                    <SelectHour Action={handleSelectHour} Hour='08:30' />
                    <SelectHour Action={handleSelectHour} Hour='09:00' />
                    <SelectHour Action={handleSelectHour} Hour='09:30' />
                    <SelectHour Action={handleSelectHour} Hour='10:00' />
                    <SelectHour Action={handleSelectHour} Hour='10:30' />
                    <SelectHour Action={handleSelectHour} Hour='11:00' />
                    <SelectHour Action={handleSelectHour} Hour='11:30' />
                    <SelectHour Action={handleSelectHour} Hour='12:00' />
                    <SelectHour Action={handleSelectHour} Hour='12:30' />
                    <SelectHour Action={handleSelectHour} Hour='13:00' />
                    <SelectHour Action={handleSelectHour} Hour='13:30' />
                </div>
            </div>

            <div className='continue-button'>
                <Button Active='true' Label='Continuar' Icon='calendar' Action='/confirmation' Direction='Next' />
            </div>
        </div>

    )
}

export default Time